import {CountryType, LanguageType} from '../common/enums/enums';

export class NewBusinessAccount {
  public firstName: string;
  public lastName: string;
  public businessName: string;
  public username: string;
  public password: string;
  public country: CountryType;
  public state: string;
  public language: LanguageType;
}
